import { ApolloClient } from '@apollo/client';

import { Team_Id_From_Old_IdDocument } from '../pages/_internal/IdResolver.query.generated';

const convertToUUID = (oldId: string): string => {
  // Ensure the ID is padded to 32 characters
  const paddedId = oldId.padStart(32, '0');
  // Format as UUID: 00000000-5b93-8ab5-0c1e8b04c15693d8
  return `${paddedId.slice(0, 8)}-${paddedId.slice(8, 12)}-${paddedId.slice(12, 16)}-${paddedId.slice(16)}`;
};

// Pour les widgets MonSiteClub avec l'ancien ID
export const resolveTeamId = async (
  teamId: string | string[] | undefined,
  client: ApolloClient
): Promise<number> => {
  if (!teamId) {
    throw new Error('Team ID is required');
  }

  const id = Array.isArray(teamId) ? teamId[0] : teamId;

  // Si l'ID est un nombre, on le retourne directement
  if (!isNaN(Number(id))) {
    return Number(id);
  }

  // Sinon, on convertit d'abord en format UUID
  const uuidId = convertToUUID(id);

  // Puis on fait une requête pour obtenir l'ID à partir de l'ancien ID
  try {
    const { data } = await client.query({
      query: Team_Id_From_Old_IdDocument,
      variables: {
        old_scorenco_id: uuidId,
      },
      context: {
        role: 'anonymous',
      },
    });

    const id = data?.teams_team?.[0]?.id;
    if (!id) {
      throw new Error('Team not found');
    }

    return id;
  } catch (error) {
    console.error('Error resolving team ID:', error);
    throw new Error('Failed to resolve team ID');
  }
};
